const rso = {
  agreement: {
    title: "Enhance your in-office dispensing with Fullscript",
    agreementCopy:
      "Even your best plans only work when patients stick to them. Fullscript offers a suite of tools to help you increase patient engagement and gather clearer clinical context – however you choose to dispense.",
    betterAccess: "Better patient engagement",
    betterAccessCopy:
      "Send them home with products and use Fullscript's daily dose reminders and other tools to promote plan adherence",
    clearerClinical: "Clearer clinical context",
    clearerClinicalCopy:
      "With current supplements, you can easily capture a breakdown of patient's daily ingredient intake before every appointment.",
    accessCopy:
      "You can access all these tools and more – without changing your in-office dispensing program. Simply connect your accounts.",
    terms:
      "I agree to Fullscript <termsLink>Terms of Service</termsLink> and <privacyLink>Privacy policy</privacyLink>.",
    next: "Connect to Fullscript",
  },
  success: {
    title: "Congratulations! You're connected to your free Fullscript account!",
    successCopy:
      "You now have access to data-driven clinical support for smarter plan building, patient engagement tools, and an endless shelf of over 400 quality brands.",
    accessCopy: "Easily access Fullscript with the same login you use for Emerson Ecologics.",
    next: "Explore Fullscript now",
  },
  error: "Error enabling account",
  errorRedirect: "Error directing to Fullscript",
  fullscriptRedirect: () => "/user/platform-redirect?target_platform_name=fullscript",
} as const;

export { rso };
